import React, { useEffect, useState } from "react";
import AuthService from "services/auth.service";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Tooltip } from "react-tooltip";

import Avatar from "components/Avatar";
import copy from "../assets/img/copy.png";
import deposit from "../assets/img/deposit-icon.png";
import bill from "../assets/img/bills-icon.png";
import moreServices from "../assets/img/more-icon.png";
import cal from "../assets/img/calendar1.png";
import checkMark from "../assets/img/check-mark.png";
import failedMark from "../assets/img/failed.png";
import pendingMark from "../assets/img/pending-mark.png";
import { API_URL_IMAGE } from "../services/config";
// react plugin used to create charts

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Label,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
// core components

import defaultImage from "../assets/img/default-avatar.png";
import authHeader from "services/auth-header";
import DepositModal from "../components/DepositModal";

const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const getLightVariant = (color) => {
  const lightenFactor = 0.7; // Adjust this factor as needed
  return color.replace(
    /^#/,
    (match) =>
      "#" +
      match
        .slice(1)
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, parseInt(color, 16) * lightenFactor).toString(16)
          ).slice(-2)
        )
  );
};

const TransactionItem = ({ title, totalFee, refundableFee, status }) => {
  const firstLetter = title.charAt(0).toUpperCase();
  const textColor = "#333"; // Dark text color
  const bgColor = getRandomColor();
  const lightBgColor = getLightVariant(bgColor);

  const roundImageStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: bgColor,
    color: "white",
    display: "inline-flex", // Display as inline-flex to have them side by side
    alignItems: "center",
    justifyContent: "center",
    padding: "5px", // Add padding for better spacing
    marginRight: "10px",
  };

  const textStyle = {
    // background: `linear-gradient(90deg, ${lightBgColor} 100%, transparent 100%)`,
    padding: "10px",
    borderRadius: "5px",
    color: "#222", // Dark text color
  };

  return (
    <td className="text-title">
      <div className="box-box">
        <div style={roundImageStyle} className="ball-mob">
          {firstLetter}
        </div>
      </div>
      <span style={textStyle}>{title}</span>
    </td>
  );
};

function Dashboard() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [masked, setMasked] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [status, setStatus] = useState("");
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  //const [showModal, setShowModal] = useState(false);
  const tcc = currentUser.tcc;
  const toggleMask = () => {
    setMasked((prevMasked) => !prevMasked);
  };

  useEffect(() => {
    const fetchStatus = () => {
      AuthService.getStatus(currentUser.id)
        .then((response) => {
          setStatus(response.data.status);
        })
        .catch((e) => {
          //console.log(e);
        });
    };

    fetchStatus(); // Fetch status initially
    const interval = setInterval(fetchStatus, 60000); // Fetch status every 60 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [currentUser.id]);

  useEffect(() => {
    checkNotification();
    retrieveTransaction();
  }, []);

  //logic to use local storage to prevent showing nnotification multiple times

  const checkNotification = () => {
    const seenNotification = localStorage.getItem("hasSeenNotification");
    if (!seenNotification) {
      fetchNotification();
    }
  };
  const retrieveTransaction = () => {
    AuthService.getAllTransaction(id)
      .then((response) => {
        // Sort transactions by createdAt date, newest first
        const sortedTransactions = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTransaction(sortedTransactions);
        //console.log("Transactions loaded:", sortedTransactions);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  // logic to fetch the pop-up for the notification
  const fetchNotification = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setNotifications(response.data);
        showNotifications(response.data);
        localStorage.setItem("hasSeenNotification", "true"); // Mark as seen after displaying toasts
      })
      .catch((error) => console.error("Error fetching notification:", error));
  };

  // Function to show notifications one by one
  const showNotifications = (notifications) => {
    let index = 0;

    const showNextNotification = () => {
      if (index < notifications.length) {
        const notification = notifications[index];
        if (!notification.read) {
          toast.warn(
            <p>
              <b>{notification.title}</b> <br /> {notification.message}{" "}
            </p>,
            {
              position: "bottom-right",
              autoClose: 7000, // Adjust time as needed
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              onClose: () => markNotificationAsRead(notification.id), //mark as read after displaying
            }
          );
        }
        index++;
        setTimeout(showNextNotification, 4000); // Delay for next notification
      }
    };

    showNextNotification();
  };

  // Function to mark a notification as read
  const markNotificationAsRead = (notificationId) => {
    AuthService.markNotificationAsRead(notificationId)
      .then(() => {
        //console.log(`Notification ${notificationId} marked as read`);
      })
      .catch((error) =>
        console.error("Error marking notification as read:", error)
      );
  };
  const handleRowClick = (transaction) => {
    setSelectedTransaction(transaction);
  };

  const closeModal = () => {
    setSelectedTransaction(null);
  };
  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      closeModal();
    }
  };

  // New function to handle withdrawal/claim refunds click
  const handleWithdrawalClick = () => {
    const pendingPayment = parseFloat(currentUser.pendingPayment) || 0;
    
    if (pendingPayment > 0) {
      // Show withdrawal modal with pending balance info
      setShowWithdrawalModal(true);
    } else {
      // If no pending payment, redirect to support for withdrawal
      window.location.href = "/user/support";
    }
  };

  // Function to handle "Pay Now" action
  const handlePayNow = () => {
    setShowWithdrawalModal(false);
    setShowDepositModal(true);
  };

  const closeWithdrawalModal = () => {
    setShowWithdrawalModal(false);
  };

  const handleWithdrawalBackdropClick = (e) => {
    if (e.target.classList.contains("modal-backdrop")) {
      closeWithdrawalModal();
    }
  };

  //logic for profile image

  const imageDir = currentUser.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;

  // Check if imageURL ends with 'none', if yes, use the default image
  if (profileImage.endsWith("none")) {
    profileImage = defaultImage;
  }

  const formatDatev = (dateString) => {
    const date = new Date(dateString);

    // Define month names for short format
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Format date components
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero if needed
    const year = date.getFullYear();

    // Format time components
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Combine into desired format
    return `${month} ${day}, ${year}`;
  };
  const formatDatew = (dateString) => {
    const date = new Date(dateString);

    // Define month names for short format
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Format date components
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero if needed
    const year = date.getFullYear();

    // Format time components
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    // Combine into desired format
    return `${month} ${day}, ${year} | ${hours}:${minutes}:${seconds}`;
  };

  // Calculate pending payment amount
  const pendingPayment = parseFloat(currentUser.pendingPayment) || 0;
  const hasPendingPayment = pendingPayment > 0;

  return (
    <>
      <ToastContainer newestOnTop={false} />
      <div className="content mid-content">
        {/* welcome row */}
        <Row className="auto-adjust">
          <Col lg="8" md="8" sm="6" className="house-all">
            <div className="typography-line-dash  line-dash-mob welcome-msg ">
              <h2>Welcome back, {currentUser.firstName}</h2>
              <p>Have a look at your balance and transactions</p>
            </div>
          </Col>
          <Col
            lg="4"
            md="4"
            sm="6"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
            className="rounded-tcc"
          >
            <div className="welcome-msg article-pan p-space">
              <p className="article-pan-p ">{tcc}</p>
              <img
                className="article-pan-img"
                src={copy}
                onClick={() => navigator.clipboard.writeText(tcc)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </Col>
        </Row>
        {/* balance cards */}
        <Row>
          <Col lg="4" md="4" sm="6" className="axct">
            <Card className="card-stats dash-purple">
              <CardBody>
                <Row className="innercol">
                  <Col>
                    <div class="card-elipse">
                      <div class="content">
                        <div className="taggg">
                          <h2 className="escrow-textttt">Current Balance</h2>
                          <div
                            className={`status-badge ${status.toUpperCase()}`}
                          >
                            <div
                              className={`status-dot ${status.toUpperCase()}`}
                            ></div>
                            {status}
                          </div>
                        </div>
                        <p class="amount big-amount">
                          {isNaN(parseFloat(currentUser.availableBalance))
                            ? "$0.00"
                            : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(currentUser.availableBalance)
                              )}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col lg="8" md="4" sm="6" className="axct">
            <Card className="card-stats dash-transparent">
              <CardBody>
                <Row className="innercol">
                  <Col>
                    <div class="card-elipse dash-details">
                      <div class="content dash-details-color">
                        <h2>Refundable Balance</h2>
                        <p class="amount big-amount">
                          {isNaN(
                            parseFloat(currentUser.transactionRefundableFee)
                          )
                            ? "$0.00"
                            : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(currentUser.transactionRefundableFee)
                              )}
                        </p>
                      </div>
                      <hr className="dash-divider" />
                      <div class="content dash-details-color">
                        <h2>Pending Charge</h2>
                        <p class="amount big-amount">
                          {" "}
                          {isNaN(parseFloat(currentUser.pendingPayment))
                            ? "$0.00"
                            : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(parseFloat(currentUser.pendingPayment))}
                        </p>
                      </div>
                      <button
                        className="dash-claim-button"
                        onClick={handleWithdrawalClick}
                        data-tooltip-variant="warning"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-position-strategy="fixed"
                        data-tooltip-delay-hide="500"
                        data-tooltip-float="true"
                        data-tooltip-content={hasPendingPayment ? "Cover outstanding charge to claim refund" : "Click to withdraw funds"}
                      >
                        {hasPendingPayment ? "Claim Refunds" : "Withdraw Funds"}
                      </button>
                      <Tooltip id="my-tooltip" />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col lg="5" md="4" sm="6" className="axct-mob">
            <Card className="card-stats dash-purple">
              <CardBody>
                <Row className="innercol">
                  <Col>
                    <div class="card-elipse mob-card-elipse">
                      <div class="content for-mob dash-purple">
                        <div className="taggg">
                          <h2 className="escrow-textttt">Current Balance</h2>
                          <div
                            className={`status-badge ${status.toUpperCase()}`}
                          >
                            <div
                              className={`status-dot ${status.toUpperCase()}`}
                            ></div>
                            {status}
                          </div>
                        </div>
                        <div className="mob-typefont fffr">
                          <div className="mob-typefont-1">
                            <p class="amount big-amount">
                              {isNaN(parseFloat(currentUser.availableBalance))
                                ? "$0.00"
                                : new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(
                                    parseFloat(currentUser.availableBalance)
                                  )}
                            </p>
                          </div>

                          <button
                            className="dash-claim-button-mob"
                            onClick={handleWithdrawalClick}
                            data-tooltip-variant="warning"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-position-strategy="fixed"
                            data-tooltip-delay-hide="500"
                            data-tooltip-float="true"
                            data-tooltip-content={hasPendingPayment ? "Cover outstanding charge to claim refund" : "Click to withdraw funds"}
                          >
                            {hasPendingPayment ? "Claim Refunds" : "Withdraw Funds"}
                          </button>
                          <Tooltip id="my-tooltip" />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col lg="7" md="4" sm="6" className="axct-mob">
            <Card className="card-stats dash-transparent">
              <CardBody>
                <Row className="innercol">
                  <Col>
                    <div class="card-elipse dash-details">
                      <div class="content dash-details-color">
                        <h2>Refundable Balance</h2>
                        <p class="amount big-amount">
                          {isNaN(
                            parseFloat(currentUser.transactionRefundableFee)
                          )
                            ? "$0.00"
                            : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(
                                parseFloat(currentUser.transactionRefundableFee)
                              )}
                        </p>
                      </div>
                      <hr className="dash-divider" />
                      <div class="content dash-details-color">
                        <h2>Pending Charge</h2>
                        <p class="amount big-amount">
                          {" "}
                          {isNaN(parseFloat(currentUser.pendingPayment))
                            ? "$0.00"
                            : new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(parseFloat(currentUser.pendingPayment))}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col lg="12" md="8" sm="6" className="house-all quick-action-house">
            <div className="typography-line-dash  line-dash-mob welcome-msg  ">
              <h2>Quick Actions </h2>
            </div>
            <div className="quick-action-hold">
              <div className="quick-action-hold-single"
              onClick={() => setShowDepositModal(true)}
              style={{ cursor: "pointer"}}
              >
                <img src={deposit} alt="Deposits" />
                
                  <span>Deposits</span>
                
              </div>
              <div
                className="quick-action-hold-single"
                onClick={handleWithdrawalClick}
                style={{ cursor: "pointer" }}
              >
                <img src={deposit} alt="Withdraw" /> 
                <span>Withdraw</span>
              </div>
              <div className="quick-action-hold-single">
                <img src={bill} alt="Bills" />{" "}
                <Link
                  to={"/user/tables"}
                  style={{
                    textDecoration: "none",
                    color: "#667085",
                  }}
                >
                  <span> Bills</span>
                </Link>
              </div>
              <div className="quick-action-hold-single">
                <img src={moreServices} alt="More Services" />
                <Link to={"/user/user-page#about"}>
                  {" "}
                  <span>More</span>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        {/* recent transaction */}
        <Row className="auto-adjust tan-house">
          <Col lg="8" md="8" sm="4" className="house-all width-mob">
            <div className="typography-line-dash  welcome-msg  ">
              <h2>Recent Transactions</h2>
              <p>Your monthly transactions</p>
            </div>
          </Col>
          <Col
            lg="4"
            md="4"
            sm="2"
            className="width-2-mob rounded-tcc"
            style={{ display: "flex", alignItems: "center" }}
          >
            <span className="tran-route">
              <Link to={"/user/tables"}>All Transactions</Link>
            </span>
          </Col>
        </Row>
        <Row>
          {/* mobile-view  */}

          <Col md="12" className="tran-mob">
            <Card>
              <CardBody>
                <Table responsive className="res-border">
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transaction.slice(0, 3).map((transaction, index) => (
                      <tr
                        key={transaction.id}
                        onClick={() => handleRowClick(transaction)}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {/* <td className="text-title">{transaction.title}</td> */}
                        <TransactionItem
                          title={transaction.title}
                          totalFee={transaction.totalFee}
                          refundableFee={transaction.refundableFee}
                          status={transaction.status}
                        />
                        <td className="fca td-end">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(transaction.totalFee))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>

          {/* desktop-view  recent transaction card  */}

          <Col lg="12" md="12">
            <Card className="hideeee">
              <CardBody>
                <Table responsive className="res-border">
                  <thead className="text-primary">
                    <tr className="table-head">
                      <th>Transaction</th>
                      <th>Total Fee Cost</th>
                      <th>Date</th>
                      <th className="">Status</th>
                      <th>Transaction ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transaction.slice(0, 3).map((transaction, index) => (
                      <tr
                        key={transaction.id}
                        onClick={() => handleRowClick(transaction)}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        {/* <td className="text-title">{transaction.title}</td> */}
                        <TransactionItem
                          title={transaction.title}
                          totalFee={transaction.totalFee}
                          refundableFee={transaction.refundableFee}
                          status={transaction.status}
                        />
                        <td className="fca">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(transaction.totalFee))}
                        </td>
                        <td className="dtaf">
                          {formatDatev(transaction.createdAt)}
                        </td>
                        <td className="text-status">
                          <div
                            className={`text-status-${
                              transaction.status ? "paid" : "pending"
                            }`}
                          >
                            {transaction.status ? (
                              <img src={checkMark} alt="Successful" />
                            ) : (
                              <img src={pendingMark} alt="Pending" />
                            )}
                            {transaction.status ? "Successful" : "Pending"}
                          </div>
                        </td>
                        <td className="fca td-end">
                          {transaction.transactionId}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Transaction Detail Modal */}
        {selectedTransaction && (
          <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
              <button className="close-button" onClick={closeModal}>
                ×
              </button>
              <h3>Transaction Receipt</h3>
              <div className="tran-rec-unit">
                <span>Amount</span>
                <h2>
                  {" "}
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(selectedTransaction.totalFee))}
                </h2>
              </div>
              <div className="tran-rec-unit">
                <span>Date</span>
                <h2> {formatDatew(selectedTransaction.createdAt)}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Payment Method</span>
                <h2> {selectedTransaction.paymentMethod}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Description</span>
                <h2> {selectedTransaction.description}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Transaction ID</span>
                <h2> {selectedTransaction.transactionId}</h2>
              </div>
              <div className="tran-rec-unit">
                <span>Status</span>
                <h2
                  className={`text-status-${
                    selectedTransaction.status ? "paid" : "pending"
                  }`}
                >
                  {" "}
                  {selectedTransaction.status ? (
                    <img src={checkMark} alt="Successful" />
                  ) : (
                    <img src={pendingMark} alt="Failed" />
                  )}
                  {selectedTransaction.status ? "Successful" : "Pending"}
                </h2>
              </div>
              {/* Add more details as needed */}
            </div>
          </div>
        )}

        {/* Withdrawal/Claim Refunds Modal */}
        {showWithdrawalModal && (
          <div
            className="modal-backdrop"
            onClick={handleWithdrawalBackdropClick}
          >
            <div className="modal-content withdrawal-modal">
              <button className="close-button" onClick={closeWithdrawalModal}>
                ×
              </button>

              <div className="withdrawal-header">
                <img src={deposit} alt="Information" className="info-icon" />
                <h3>{hasPendingPayment ? "Claim Refunds" : "Withdraw Funds"}</h3>
              </div>

              <div className="withdrawal-notice">
                {hasPendingPayment ? (
                  <>
                    <div className="pending-balance-alert">
                      <div className="alert-icon">⚠️</div>
                      <div className="alert-content">
                        <h4>Outstanding Balance Due</h4>
                        <p className="pending-amount">
                          You have an outstanding balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(pendingPayment)}
                          </strong>
                        </p>
                      </div>
                    </div>

                    <div className="notice-points">
                      <div className="notice-point">
                        <p>
                          <strong>Clear Outstanding Balance:</strong> Before you can withdraw funds or claim refunds, you must clear your outstanding balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(pendingPayment)}
                          </strong>
                        </p>
                      </div>

                      <div className="notice-point">
                        <p>
                          <strong>Refund Eligibility:</strong> Your refundable balance of{" "}
                          <strong>
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                          </strong>{" "}
                          will become available for withdrawal once all pending payments are cleared.
                        </p>
                      </div>

                      <div className="notice-point">
                        <p>
                          <strong>Payment Methods:</strong> You can pay your outstanding balance using any of our available deposit methods including cryptocurrency, P2P payments, or gift cards.
                        </p>
                      </div>
                    </div>

                    <div className="balance-summary">
                      <div className="balance-item">
                        <span>Outstanding Balance:</span>
                        <span className="amount negative">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(pendingPayment)}
                        </span>
                      </div>
                      <div className="balance-item">
                        <span>Refundable Balance:</span>
                        <span className="amount positive">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="no-pending-balance">
                    <div className="success-icon">✅</div>
                    <h4>No Outstanding Balance</h4>
                    <p>Your account is in good standing. You can proceed with withdrawals.</p>
                    
                    <div className="balance-summary">
                      <div className="balance-item">
                        <span>Available for Withdrawal:</span>
                        <span className="amount positive">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(parseFloat(currentUser.transactionRefundableFee) || 0)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="withdrawal-actions">
                {hasPendingPayment ? (
                  <>
                    <button
                      className="primary-btn pay-now-btn"
                      onClick={handlePayNow}
                    >
                      Pay Outstanding Balance
                    </button>
                    <button
                      className="secondary-btn"
                      onClick={closeWithdrawalModal}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <button
                    className="primary-btn"
                    onClick={() => {
                      closeWithdrawalModal();
                      window.location.href = "/user/support";
                    }}
                  >
                    Proceed to Withdrawal
                  </button>
                )}
              </div>

              <div className="contact-support">
                <p>
                  Need assistance? Our <a href="/support">support team</a> is available to help with any questions regarding your account balance or payment process.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Deposit Modal */}
        {showDepositModal && (
          <DepositModal 
            isOpen={showDepositModal} 
            onClose={() => setShowDepositModal(false)} 
          />
        )}
      </div>

      {/* Add CSS for the new modal styles */}
      <style jsx>{`
        .pending-balance-alert {
          display: flex;
          align-items: center;
          background: #fff3cd;
          border: 1px solid #ffeaa7;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 20px;
        }
        
        .alert-icon {
          font-size: 24px;
          margin-right: 12px;
        }
        
        .alert-content h4 {
          margin: 0 0 8px 0;
          color: #856404;
        }
        
        .pending-amount {
          margin: 0;
          color: #856404;
          font-size: 18px;
        }
        
        .balance-summary {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 16px;
          margin: 20px 0;
        }
        
        .balance-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
        }
        
        .balance-item:not(:last-child) {
          border-bottom: 1px solid #dee2e6;
        }
        
        .amount.negative {
          color: #dc3545;
          font-weight: bold;
        }
        
        .amount.positive {
          color: #28a745;
          font-weight: bold;
        }
        
        .pay-now-btn {
          background: #dc3545;
          border-color: #dc3545;
        }
        
        .pay-now-btn:hover {
          background: #c82333;
          border-color: #bd2130;
        }
        
        .no-pending-balance {
          text-align: center;
          padding: 20px;
        }
        
        .success-icon {
          font-size: 48px;
          margin-bottom: 16px;
        }
        
        .no-pending-balance h4 {
          color: #28a745;
          margin-bottom: 8px;
        }
      `}</style>
    </>
  );
}

export default Dashboard;